import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EndpointGroupsSearchPipe, GroupEndpointsSearchPipe } from './endpoint-groups.pipe';


@NgModule({
  declarations: [EndpointGroupsSearchPipe, GroupEndpointsSearchPipe],
  exports: [EndpointGroupsSearchPipe, GroupEndpointsSearchPipe],
  imports: [
    CommonModule,
  ],
  providers: [EndpointGroupsSearchPipe, GroupEndpointsSearchPipe]
})
export class EndpointGroupsSearchPipeModule { }
